/**
 * Radar list endpoints take `lookback_days` (1–30). Analytic profiles store `time_window_hours`.
 */
export function radarLookbackDaysFromProfile(profile: { time_window_hours?: number } | null | undefined): number {
  const h = profile?.time_window_hours;
  if (typeof h === 'number' && Number.isFinite(h) && h > 0) {
    const days = Math.ceil(h / 24);
    return Math.min(30, Math.max(1, days));
  }
  return 3;
}
